import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import APModal from 'components/Modal/APModal';
import CreateQuickNote from './CreateQuickNote';
import CreateNoteSettings from './CreateNote.Settings';

import './create-note.scss';

const CreateNoteModal = ({ open, onClose, createNote, weddingId, templateFolders = [], templates = [] }) => {
  const [type, setType] = useState(-1);
  const [title, setTitle] = useState('Create a note.');
  const [showCreateNoteSettings, setShowCreateNoteSettings] = useState(false);
  const topRef = useRef(null);
  const [modalSize, setModalSize] = useState('medium');

  useEffect(() => {
    if (!open) {
      setType(-1);
      setTitle('Create a note.');
      setShowCreateNoteSettings(false);
      setModalSize('medium');
    }
  }, [open]);

  const updateType = (value) => {
    setType(value);
  };

  const updateTitle = () => {
    if (type === 0) {
      setTitle('Create a new shortcut.');
    }
    else if (type === 1) {
      setTitle('Create a new note.');
    }
    else if (type === 2) {
      setTitle('Add from template.');
    }
  };

  const openCreateNoteSettings = () => {
    setShowCreateNoteSettings(true);
    if (type === 2) {
      setModalSize('small');
    } else {
      setModalSize('medium');
    }
    updateTitle();
    topRef.current?.scrollIntoView({ block: 'end' });
  };

  return (
    <>
      <APModal
        open={open}
        title={title}
        name='create-note'
        onClose={onClose}
        size={modalSize}
      >
        <div ref={topRef} />
        {showCreateNoteSettings ? (
          <CreateNoteSettings
            type={type}
            weddingId={weddingId}
            templateFolders={templateFolders}
            templates={templates}
            createNote={createNote}
            closeNoteModal={onClose}
          />
        ) : (
          <CreateQuickNote
            type={type}
            updateType={updateType}
            openCreateNoteSettings={openCreateNoteSettings}
            setModalSize={setModalSize}
          />
        )}
      </APModal>
    </>
  );
};
CreateNoteModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  createNote: PropTypes.func,
  weddingId: PropTypes.string,
};

CreateNoteModal.defaultProps = {};

export default CreateNoteModal;
